import React, { createContext, useReducer, useState } from 'react'
import { PostReducer } from './PostReducer'

import {
  apiUrl,
  POSTS_LOADED_SUCCESS,
  POSTS_LOADED_FAIL,
  POST_LOADED_SUCCESS,
  POST_LOADED_FAIL,
  DELETE_POST
} from '../constants/constants'
import axios from 'axios'
import uuid from 'react-uuid'

export const PostContext = createContext()

const PostContextProvider = ({ children }) => {
  const [postState, dispatch] = useReducer(PostReducer, {
    posts: [],
    post: {}
  })

  const [showToast, setShowToast] = useState({
    show: false,
    message: '',
    type: null
  })

  //get all Post
  const getAllPosts = async (date1, date2) => {
    try {
      const newUid = uuid()
      if (date1 && date2) {
        let date4 = new Date(
          new Date(date2).setHours(23, 59, 59, 999)
        ).toISOString()
        const res = await axios.get(
          `${apiUrl}/posts/adminGetPosts?v=${newUid}&date1=${date1}&date2=${date4}`,
          {
            headers: {
              token:
                'Bearer ' + JSON.parse(localStorage.getItem('user')).accessToken
            }
          }
        )
        if (res.data.success) {
          dispatch({ type: POSTS_LOADED_SUCCESS, payload: res.data.data })
          //return res.data
        }
      } else {
        const res = await axios.get(
          `${apiUrl}/posts/adminGetPosts?v=${newUid}`,
          {
            headers: {
              token:
                'Bearer ' + JSON.parse(localStorage.getItem('user')).accessToken
            }
          }
        )

        if (res.data.success) {
          dispatch({ type: POSTS_LOADED_SUCCESS, payload: res.data.data })
          //return res.data
        }
      }
    } catch (error) {
      // return error.response.data
      dispatch({ type: POSTS_LOADED_FAIL })
    }
  }
  //get post by post id
  //get user
  const getPostById = async (id) => {
    try {
      const res = await axios.get(`${apiUrl}/posts/${id}`, {
        headers: {
          token:
            'Bearer ' + JSON.parse(localStorage.getItem('user')).accessToken
        }
      })
      if (res.data.success) {
        dispatch({ type: POST_LOADED_SUCCESS, payload: res.data.post })
        return res.data.post
      }
    } catch (error) {
      return error.response.data
      dispatch({ type: POST_LOADED_FAIL })
    }
  }
  //delete post

  const deletePostByAdmin = async (postId) => {
    try {
      const response = await axios.delete(`${apiUrl}/posts/byadmin/${postId}`, {
        headers: {
          token:
            'Bearer ' + JSON.parse(localStorage.getItem('user')).accessToken
        }
      })
      if (response.data.success) {
        dispatch({ type: DELETE_POST, payload: postId })
        return response.data
      }
    } catch (error) {
      console.log(error)
    }
  }

  const deletePost = async (postId) => {
    try {
      const response = await axios.delete(`${apiUrl}/posts/${postId}`, {
        headers: {
          token:
            'Bearer ' + JSON.parse(localStorage.getItem('user')).accessToken
        }
      })
      if (response.data.success) {
        dispatch({ type: DELETE_POST, payload: postId })
        return response.data
      }
    } catch (error) {
      console.log(error)
    }
  }

  //get post by user
  const getPosts = async (date1, date2, id) => {
    try {
      const newUid = uuid()
      if (date1 && date2) {
        let date4 = new Date(
          new Date(date2).setHours(23, 59, 59, 999)
        ).toISOString()

        const res = await axios.get(
          `${apiUrl}/posts/byuser/${id}?v=${newUid}&id=${id}&date1=${date1}&date2=${date4}`,
          {
            headers: {
              token:
                'Bearer ' + JSON.parse(localStorage.getItem('user')).accessToken
            }
          }
        )

        if (res.data.success) {
          dispatch({ type: POSTS_LOADED_SUCCESS, payload: res.data.posts })
          //return res.data
        }
      } else {
        const res = await axios.get(
          `${apiUrl}/posts/byuser/${id}?v=${newUid}`,
          {
            headers: {
              token:
                'Bearer ' + JSON.parse(localStorage.getItem('user')).accessToken
            }
          }
        )

        if (res.data.success) {
          dispatch({ type: POSTS_LOADED_SUCCESS, payload: res.data.posts })
          //  return res.data
        }
      }
    } catch (error) {
      console.log(error)
      //  return error.response.data
      dispatch({ type: POSTS_LOADED_FAIL })
    }
  }

  //context data
  const PostContextData = {
    postState,
    getPosts,
    showToast,
    setShowToast,
    getAllPosts,
    getPostById,
    deletePost,
    deletePostByAdmin
    // addTodo,
    // deleteTodo,
  }
  return (
    <PostContext.Provider value={PostContextData}>
      {children}
    </PostContext.Provider>
  )
}

export default PostContextProvider
